import kardiaPopupComponent from './kardiaPopup.component';

const kardiaPopupModule = angular.module('app.components.clinicalData.subjects.kardiaPopup', [])
	.component('kardiaPopup', kardiaPopupComponent)
	.name;

export default kardiaPopupModule;
